import { useExportPackages } from "@/features/packages/hooks/usePackages";
import { Button } from "@shared/components/ui/button";
import { FileDown } from "lucide-react";
import { useTranslation } from "react-i18next";

const ExportPackages = ({ filter }) => {
  const { t } = useTranslation();
  const exportPackages = useExportPackages(filter);

  const handleExport = () => {
    exportPackages.mutate();
  };

  return (
    <Button onClick={handleExport} disabled={exportPackages.isLoading}>
      <FileDown />
      {exportPackages.isPending ? t("common.exporting") : t("common.export")}
    </Button>
  );
};

export default ExportPackages;
